import { ZustandCasinoDrawerStore } from './types';

export const isFullCasinoDrawerSelector = (state: ZustandCasinoDrawerStore) =>
  state.isFullView;

// Actions

export const setFullCasinoDrawerAction = (state: ZustandCasinoDrawerStore) =>
  state.setCasinoDrawerView;
